var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightThemeMailzzyCollaspedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12136 5.85477C9.12136 5.85477 5.89636 5.98811 5.93936 9.18811C5.98236 12.3881 5.93936 25.277 5.93936 25.277C5.93936 25.277 6.77786 28.8103 9.76636 28.8992C12.7549 28.9881 30.4279 28.8992 30.4279 28.8992C30.4279 28.8992 33.6314 28.5214 34.2549 25.0992V8.25477C34.2549 8.25477 34.0614 5.877 31.1374 6.077C31.1374 6.077 34.0614 2.477 39.1569 4.54366C39.1569 4.54366 40.1674 6.43255 40.1674 9.74366C40.1674 13.0548 40.1674 25.2326 40.1674 25.2326C40.1674 25.2326 39.5439 34.3437 30.5139 35.0326H8.19686C8.19686 35.0326 0.865363 33.8326 0.0268632 25.7659C0.0268632 24.6548 0.0268632 23.5437 0.0268632 22.4326C0.0268632 20.077 0.0268632 17.7214 0.0268632 15.3437C0.0268632 13.2103 0.0268632 11.077 0.0268632 8.92144C0.0268632 8.36588 -0.0161367 7.74366 0.0698633 7.16589C0.177363 6.56589 0.478363 5.98811 0.822363 5.477C1.46736 4.477 2.45636 3.69922 3.66036 3.69922C4.04736 3.69922 4.41286 3.877 4.79986 3.89922C8.88486 4.14366 9.12136 5.85477 9.12136 5.85477Z",
    fill: "url(#paint0_linear_15802_8640)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00512539 10.7676V7.96758C0.00512539 7.96758 -0.274375 4.92314 3.29463 3.7898C6.86363 2.65647 9.12113 5.85647 9.12113 5.85647C9.12113 5.85647 6.32613 5.83425 5.96063 8.76758V10.7676",
    fill: "url(#paint1_linear_15802_8640)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.757812 5.65413C0.757812 5.65413 3.25181 0.143016 13.0558 8.80968C13.0558 8.80968 16.4743 11.1652 20.1078 6.67635L13.8513 1.87635C13.8513 1.87635 5.89631 -4.25698 0.757812 5.65413Z",
    fill: "url(#paint2_linear_15802_8640)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2547 10.7878V8.25451C34.2547 8.25451 34.1042 5.81007 31.1372 6.07674C31.1372 6.07674 34.5342 2.61007 39.1567 4.5434C39.1567 4.5434 40.1672 6.07674 40.1672 10.7878",
    fill: "url(#paint3_linear_15802_8640)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6255 8.49954C12.6255 8.49954 14.926 9.72176 19.183 7.36621C23.526 4.27732 28.084 -0.678236 32.4055 0.0773194C36.727 0.832875 39.178 4.52176 39.178 4.52176C39.178 4.52176 34.7275 3.38843 31.7175 5.6551C28.7075 7.92176 28.686 7.92176 28.686 7.92176L20.1075 14.3884L12.6255 8.49954Z",
    fill: "#C11D85"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15802_8640",
    x1: 0.00753478,
    y1: 19.3713,
    x2: 40.1765,
    y2: 19.3713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#C11D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4805,
    stopColor: "#5A3C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8101,
    stopColor: "#1C0F24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15802_8640",
    x1: 3.17825,
    y1: 9.36789,
    x2: 7.37172,
    y2: 0.990549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027962,
    stopColor: "#E31F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15802_8640",
    x1: 13.3451,
    y1: 11.4005,
    x2: 6.5154,
    y2: -0.0443512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C449B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15802_8640",
    x1: 35.6568,
    y1: 10.7844,
    x2: 35.6568,
    y2: 3.9586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027962,
    stopColor: "#1C0F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightThemeMailzzyCollaspedLogo);
export default __webpack_public_path__ + "static/media/light_theme_mailzzy_collasped_logo.aa01f6531d88676619698c3e7ae304ca.svg";
export { ForwardRef as ReactComponent };